<template>
  <el-container>
    <el-header class="a-h">
      <el-input placeholder="请输入小区名称" v-model="likeData"></el-input>
      <el-button type="primary" @click="queryHousing()">查询</el-button>
    </el-header>
    <el-main>
      <el-table
        :data="housingData"
        :show-header="false"
        default-expand-all
        ref="tablesure"
        row-key="userId"
        :tree-props="{ children: 'users' }"
        highlight-current-row
        @row-click="houseClick"
      >
        <el-table-column prop="userName" label="名字"></el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "AsideTable",
  props: {
    active: {
      type: String,
      default: ""
    },
    userinfo: {
      type: Object
    }
  },
  data() {
    return {
      likeData: "",
      housingData: []
    };
  },
  computed: {},
  created() {
    this.queryHousing();
  },
  mounted() {},
  methods: {
    /*
     **  @description 查询小区数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryHousing() {
      let url = "/dapi/u/likeSelectUserInfo";
      let params = {
        uid: this.userinfo.uid,
        likeData: this.likeData
      };
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            this.housingData = [];
            data.data.map(item => {
              if (
                item.userRoleCode == 3 ||
                item.userRoleCode == 9 ||
                (item.users && item.users.length > 0)
              ) {
                this.housingData.push(item);
              }
            });
            this.houseClick(this.housingData[0]);
          } else {
            this.$message.error(data.message);
          }
        })
        .catch(res => {
          this.$message.error("服务器异常！");
        });
    },
    /*
     **  @description 小区点击
     **  @param {}
     **  @return
     **  @author shipingan
     */
    houseClick(row) {
      let k = this.housingData.indexOf(row);
      this.$refs.tablesure.setCurrentRow(this.housingData[k]);
      this.$emit("active", row);
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.el-container {
  box-shadow: @box-shadow;
  height: 100%;
  .a-h {
    display: flex;
    padding: 16px 20px;
    box-shadow: @box-shadow;
    .el-input {
      margin-right: 10px;
    }
  }
}
</style>
